export default __webpack_public_path__ + "static/media/input-placeholder.7c3c1da2.svg";